import React from 'react';
import { useSelector } from 'react-redux';
import {
  Grid,
  Avatar,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@material-ui/core';

import {
  AssignmentInd,
  // PhoneAndroid,
  // MailOutline,
  ErrorOutline,
} from '@material-ui/icons';

import useStyles from './styles';

const Perfil = () => {
  const classes = useStyles();
  const user = useSelector((state) => state.auth.usuario);

  return (
    <>
      <Grid container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <h2>Mi perfil</h2>
          <Paper spacing={3} className={classes.paper}>
            <Grid item xs={12} md={6}>
              <List>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar color='secundary' style={{ backgroundColor: '#00b0ff' }}>
                      {user.nombre.substr(0, 1)}
                      {user.apellido.substr(0, 1)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={user.nombre + ' ' + user.apellido} />
                </ListItem>
              </List>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper spacing={3} className={classes.paper}>
            <Grid item xs={12} md={6}>
              <List>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <AssignmentInd />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary='Numero de Documento' secondary={user.dni} />
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <AssignmentInd />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary='Numero de Tramite' secondary={user.nroTramite} />
                </ListItem>
                {/* <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <PhoneAndroid />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary='Numero de contacto' secondary={user.telefono} />
                </ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <MailOutline />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary='Correo de contacto' secondary={user.email} />
                </ListItem> */}
              </List>
            </Grid>
          </Paper>
        </Grid>
        {/* <Grid item xs={12}>
          <Paper item xs={12} md={12} className={classes.paper}>
            <List>
              <ListItem>
                <ListItemAvatar>
                  <ErrorOutline />
                </ListItemAvatar>
                Solicitar certificado único habilitante para circulación -
                <b>
                  <a target='_blank' href='https://www.argentina.gob.ar/circular'>
                    Emergencia COVID-19
                  </a>
                </b>
              </ListItem>
            </List>
          </Paper>
        </Grid> */}
      </Grid>
    </>
  );
};

export default Perfil;
